'use client';

import { useEffect, useRef } from 'react';
import { appComponentsStorage } from '../../storage';
import { useActiveAccountId } from '../ActiveEntitiesContext';
import { useAccountVersion } from './useAccountVersion';

export const UpdateLastViewedAccountId = () => {
  const storedLastViewedAccountId = useRef<string | undefined>(undefined);
  const accountId = useActiveAccountId();
  const accountVersion = useAccountVersion();

  // Load value saved in localStorage into ref
  useEffect(() => {
    if (!storedLastViewedAccountId.current) {
      storedLastViewedAccountId.current = appComponentsStorage.get(
        'lastViewedAccountId'
      );
    }
  }, []);

  // Save the last viewed account ID to localStorage when it changes
  useEffect(() => {
    if (!accountId) return;
    if (typeof accountVersion === 'undefined') return;
    if (accountVersion < 4) return;
    if (storedLastViewedAccountId.current !== accountId) {
      appComponentsStorage.set('lastViewedAccountId', accountId);
      (window as any).__LAST_VIEWED_ACCOUNT_ID__ = accountId;
      storedLastViewedAccountId.current = accountId;
    }
  }, [accountId, accountVersion]);
  return null;
};
